import React from "react";
import { Privacy } from "../../components/privacy/privacy.component";

export const PrivacyPage = () => {
  return <Privacy />;
};
